// extracted by mini-css-extract-plugin
export var errorsContainer = "_tj-1";
export var link = "_tj-0";